import React from "react";

import {
  useMyEmailSettings,
  useUpdateEmailSettings,
} from "../services/useGetSetMyEmailSettings";
//import { useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";

import FirstRunEmailOption from "./FirstRunEmailOption";
import {
  useQuery,
  useMutation,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import FormGroup from "@mui/material/FormGroup";

interface props {
  onEmailSettingsChange: (someSettingsSet: boolean) => void;
}

const queryClient = new QueryClient();

const FirstRunEmailSettings: React.FC<props> = (props) => {
  const { isAuthenticated } = useAuth0();

  if (isAuthenticated) {
    return (
      <>
        <QueryClientProvider client={queryClient}>
          <EmailSettings />
        </QueryClientProvider>
      </>
    );
  } else {
    return <></>;
  }

  function EmailSettings() {
    const query = useQuery({
      queryKey: ["emailSettings"],
      queryFn: useMyEmailSettings(),
    });

    const mutation = useMutation({
      mutationFn: useUpdateEmailSettings(),
      onSuccess: () => {
        // Invalidate and refetch
        queryClient.invalidateQueries({ queryKey: ["emailSettings"] });
        //count the number of items in query.data.categories where adminHigh is true and userHigh is true
        const count = query.data?.categories?.filter(
          (category) =>
            category.adminHigh &&
            category.userHigh &&
            category.userMedium &&
            category.adminMedium
        ).length;
        //If count is greater than 0, set the email settings to true
        //Otherwise set it to false
        console.log("count", count);
        props.onEmailSettingsChange(count != null ? count > 0 : false);
      },
    });

    const Save = async () => {
      if (query.data != null) {
        const model = {
          cadence: "W",
          categories: query.data.categories,
        };
        const result = await mutation.mutateAsync(model);
        return result;
      }
    };

    const handleEmailOptionChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const { name, checked } = event.target;
      //Find the category in query.data.categories and update it
      const category = query.data?.categories?.find(
        (category) => category.category === name
      );
      if (category) {
        category.adminHigh = checked;
        category.userHigh = checked;
        category.adminMedium = checked;
        category.userMedium = checked;
      }
      Save();
    };

    return (
      <div>
        <div>
          <FormGroup row style={{ justifyContent: "center" }}>
            {query.data?.categories?.map((item, index) => (
              <FirstRunEmailOption
                key={index}
                initiallySelected={
                  item.adminHigh &&
                  item.userHigh &&
                  item.userMedium &&
                  item.adminMedium
                }
                name={item.category}
                onChange={handleEmailOptionChange}
              />
            ))}
          </FormGroup>
        </div>
      </div>
    );
  }
};
export default FirstRunEmailSettings;
